import { env } from "@/lib/env";
import { buildToolUrl } from "@/lib/tools/toolUrls";
import { queueToolCommand } from "@/lib/tools/toolIframeRegistry";
import {
  amainvoiceId,
  amainvoiceTab,
  billbeeId,
  billbeeTab,
  replycoId,
  replycoTab,
  ventoryOneId,
  ventoryOneTab,
} from "@/lib/tabs/registry";
import { activateTab, openTab } from "@/data/slices/tabsSlice";
import {
  selectIsImpersonated,
  selectUserEmail,
} from "@/data/selectors/auth";
import {
  selectAmainvoiceLink,
  selectBillbeeLink,
  selectReplycoLink,
  selectVentoryOneLink,
} from "@/data/selectors/orgs";

const TOOL_DEFINITIONS = {
  amainvoice: {
    id: amainvoiceId,
    tab: amainvoiceTab,
    config: () => env.tools.amainvoice,
    link: selectAmainvoiceLink,
  },
  billbee: {
    id: billbeeId,
    tab: billbeeTab,
    config: () => env.tools.billbee,
    link: selectBillbeeLink,
  },
  replyco: {
    id: replycoId,
    tab: replycoTab,
    config: () => env.tools.replyco,
    link: selectReplycoLink,
  },
  ventoryone: {
    id: ventoryOneId,
    tab: ventoryOneTab,
    config: () => env.tools.ventoryOne,
    link: selectVentoryOneLink,
  },
};

export const executeToolCommand =
  ({ tool, command, relatedEntities, metadata }) =>
  (dispatch, getState) => {
    const normalizedTool = String(tool || "").trim().toLowerCase();
    const definition = TOOL_DEFINITIONS[normalizedTool];
    if (!definition) return;

    const state = getState();
    const config = definition.config();
    const url = buildToolUrl(
      config.url,
      definition.link(state),
      selectUserEmail(state),
      selectIsImpersonated(state),
    );

    if (!url) return;

    const tabId = definition.id();
    if (state.tabs?.byId?.[tabId]) {
      dispatch(activateTab(tabId));
    } else if (config.supportsIframe) {
      dispatch(openTab(definition.tab(url)));
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }

    queueToolCommand({
      tool: normalizedTool,
      command,
      relatedEntities,
      metadata,
    });
  };
